import React from 'react';
import clsx from 'clsx';

export const NewBadge = ({ forHeader }: { forHeader?: boolean }) => (
  <div
    className={clsx(
      'flex h-[18px] w-[30px] flex-shrink-0 items-center justify-center bg-base900 px-1 py-[2px] text-[10px] font-semibold leading-[14px] text-white',
      forHeader ? 'rounded-[6px]' : 'rounded-bl-[6px] rounded-tr-[6px]',
    )}
  >
    New
  </div>
);
